module.exports = __webpack_public_path__ + "static/media/Select_UI.8412aafd.wav";